/* global google */
import React, { useEffect } from "react"
import Helmet from "react-helmet"
import { injectIntl } from "react-intl"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import { ThemeProvider } from "@ridecell/web-components-material"
import moment from "moment"
import "moment/locale/es"
import "moment/locale/it"
import "moment/locale/fr"

import HomePage from "./pages/HomePage"
import RegistrationPage from "./pages/RegistrationPage"
import { history } from "../src/utils/history"
import css from "./App.css" // eslint-disable-line
import LoginPage from "./pages/LoginPage"
import NotFoundPage from "./pages/NotFoundPage"
import useInitializeSDK from "./utils/customHooks/useInitializeSDK"
import useGlobalContext from "./utils/customHooks/useGlobalContext"
import GlobalProvider from "./store/GlobalProvider"
import PrivateRoute from "./utils/PrivateRoute"
import { BackDropLoader } from "./components/Loaders"

import { BundleProvider } from "@ridecell/web-i18n"
import config from "./config/phrase.config.json"
import messages from "./messages"

//TODO: Export to another file and add styiling for loaders state
const AppWithSDK = (props) => {
  const { initSDK } = useInitializeSDK()
  const {
    state: { sdkInitialized, sdkError },
  } = useGlobalContext()

  useEffect(() => {
    if (!sdkInitialized) initSDK()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdkInitialized])

  return (
    <div>
      {sdkInitialized && <div>{props.children}</div>}
      {!sdkInitialized && !sdkError && (
        <BackDropLoader initLoader={true} open={!sdkInitialized && !sdkError} />
      )}
      {sdkError && <div>Error initializing SDK. </div>}
    </div>
  )
}

const HelmetRC = ({ intl: { formatMessage } }) => (
  <Helmet title={formatMessage(messages.customerPortal)} />
)

const HelmetWithIntl = injectIntl(HelmetRC)

const App = () => {
  const {
    state: { showBackdrop, tenantSettings },
    setAuthenticated,
    setCurrentUser,
  } = useGlobalContext()

  const phraseProjectIds = [tenantSettings?.phraseCustomerPortalProjectId]
  const defaultLocale = tenantSettings?.defaultLocale
  const localStorageCustomer = localStorage.getItem("customer")
  const localStorageAuthToken = localStorage.getItem("authToken")
  moment.locale(navigator.language || defaultLocale)

  useEffect(() => {
    if (localStorageCustomer && localStorageAuthToken) {
      setCurrentUser(JSON.parse(localStorageCustomer))
      setAuthenticated(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ThemeProvider>
      <AppWithSDK>
        <BundleProvider
          accessToken={config.accessToken}
          defaultLocale={defaultLocale}
          projectID={phraseProjectIds}
        >
          <React.Fragment>
            <HelmetWithIntl />
            <BrowserRouter basename="reserve" history={history}>
              <Switch>
                <PrivateRoute exact path={["/", "/trips", "/settings"]}>
                  <HomePage />
                </PrivateRoute>
                <Route exact path={"/signup"} component={RegistrationPage} />
                <Route exact path={"/login"} component={LoginPage} />
                <Route component={NotFoundPage} />
              </Switch>
              {showBackdrop && <BackDropLoader open={showBackdrop} />}
            </BrowserRouter>
          </React.Fragment>
        </BundleProvider>
      </AppWithSDK>
    </ThemeProvider>
  )
}

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
  <GlobalProvider>
    <App />
  </GlobalProvider>
)
